// Libs
import * as THREE from "three"

// Helpers three
import Scene3d from "../Scene3d";
import Scene3dSMAA from "../Scene3dSMAA";
import Scene3dFXAA from "../Scene3dFXAA";

// Utils
import Utils from "../../../utils/utils";


export default class SceneWithRaycaster extends Scene3dSMAA{

    constructor(container, parameters, data){
        super(container, parameters, data)

        // variables
        this.intersectableObjects = []

        // parameters

        this.data.disableRaycaster = Utils.isUndefined(data.disableRaycaster) ? false : data.disableRaycaster

        this.mouse = new THREE.Vector2()
        this.raycaster = new THREE.Raycaster()
        this.hoveredMesh = null

        // binds
        this.onMouseMove = this.onMouseMove.bind(this)
    }

    /** Core */

    /** Interfaces methods */
    onMouseEnterMesh(intersect){
        this.hoveredMesh = intersect.object
    }

    onMouseMoveMesh(intersect){}

    onMouseLeaveMesh(){
        this.hoveredMesh = null
    }

    /** Helpers */

    /** Events */

    applyRaycaster(){

        // set raycaster position
        this.raycaster.setFromCamera( this.mouse, this.camera )

        // calculate objects intersecting the picking ray
        let intersects = this.raycaster.intersectObjects(this.intersectableObjects)
        
        if(intersects.length){
            let intersectedMesh = intersects.filter(i => i && i.object)[0]

            if(intersectedMesh){

                // already an mesh hovered
                if(this.hoveredMesh){

                    // mouse is still into hoveredMesh
                    if(this.hoveredMesh.uuid === intersectedMesh.object.uuid){
                        this.onMouseMoveMesh(intersectedMesh)
                        return
                    } 
                    // mouse is now in an other mesh
                    else {
                        this.onMouseLeaveMesh()
                    }
                }

                this.onMouseEnterMesh(intersectedMesh)
                this.onMouseMoveMesh(intersectedMesh)
                return
            }

        }

        if(this.hoveredMesh){            
            this.onMouseLeaveMesh()
        }
    
    }

    onMouseMove(event){
        this.mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1
        this.mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1
        
        this.applyRaycaster()
    }

    attachEvents(){
        super.attachEvents()

        if(this.data.disableRaycaster) return
        this.container.addEventListener("mousemove", this.onMouseMove)
    }

    removeEvents(){
        super.removeEvents()

        if(this.data.disableRaycaster) return
        this.container.removeEventListener("mousemove", this.onMouseMove)
    }
}